import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=305b9ac5&scoped=true&"
import script from "./BalanceView.vue?vue&type=script&lang=ts&"
export * from "./BalanceView.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=305b9ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b9ac5",
  null
  
)

export default component.exports